import { registerPlugin } from "@capacitor/core";

/**
 * Thermal Printer Plugin
 * Simple wrapper for BLD Print Service
 */
const ThermalPrinter = registerPlugin("ThermalPrinter");

export default ThermalPrinter;
